module.exports = __webpack_public_path__ + "static/img/map.a5c1756.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map.gif
// module id = ARH2
// module chunks = 0